import { render, staticRenderFns } from "./DepartmentEditor.vue?vue&type=template&id=310f56bc&scoped=true&"
import script from "./DepartmentEditor.vue?vue&type=script&lang=ts&"
export * from "./DepartmentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentEditor.vue?vue&type=style&index=0&id=310f56bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f56bc",
  null
  
)

export default component.exports